import { regExpVisa, regExpMaster, regExpElo } from 'src/componentes/regexp'
import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'

const caracter = Yup.string().required(mensagemPadrao)
const codigoSegurancaMensagem = 'CVV inválido'
const mensagemCartaoInvalido = 'Cartão de Crédito inválido'

const numeroCartaoVisaMasterEloValido = (
  valor: string | undefined
): boolean => {
  const novoValor = (valor ?? '').replaceAll(' ', '')
  return (
    !!novoValor.match(regExpVisa) ||
    !!novoValor.match(regExpMaster) ||
    !!novoValor.match(regExpElo)
  )
}

export const schemaPagamentoCartaoCredito = Yup.object().shape({
  numero: Yup.string().cartaoCredito().required(mensagemPadrao),
  nomeImpresso: caracter,
  validade: Yup.string().validadeCartaoCredito().required(mensagemPadrao),
  codigo: Yup.string()
    .nullable()
    .min(3, codigoSegurancaMensagem)
    .max(4, codigoSegurancaMensagem)
    .required(mensagemPadrao)
})

export const schemaPagamentoCartaoCreditoVisaMasterElo = Yup.object().shape({
  numero: Yup.string()
    .required(mensagemPadrao)
    .test('bandeiras', mensagemCartaoInvalido, valor =>
      numeroCartaoVisaMasterEloValido(valor)
    ),
  nomeImpresso: caracter,
  validade: Yup.string().validadeCartaoCredito().required(mensagemPadrao),
  codigo: Yup.string()
    .nullable()
    .min(3, codigoSegurancaMensagem)
    .max(4, codigoSegurancaMensagem)
    .required(mensagemPadrao)
})
